/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Enable_ButtonInputs */

const fr_totp_enable_button = /** @type {(inputs: Totp_Enable_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le TOTP`)
};

/**

* @param {Totp_Enable_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_enable_button = /** @type {((inputs?: Totp_Enable_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Enable_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_enable_button(inputs)
});